import { LucideIcon } from "lucide-react";

interface WorkflowInsuranceTypesProps {
  types: Array<{
    name: string;
    icon: LucideIcon;
  }>;
}

export const WorkflowInsuranceTypes = ({ types }: WorkflowInsuranceTypesProps) => (
  <div className="grid grid-cols-3 gap-3 sm:gap-4 mt-4">
    {types.map((type, i) => {
      const TypeIcon = type.icon;
      return (
        <div key={i} className="text-center">
          <TypeIcon className="mx-auto mb-1 text-primary" size={20} />
          <div className="text-xs sm:text-sm text-neutral">{type.name}</div>
        </div>
      );
    })}
  </div>
);